<template>
  <v-row>
    <v-col cols="auto" v-if="items.length > 1">
      <v-select
        prepend-icon="mdi-magnify"
        :items="items"
        v-model="field"
        label="Search By"
        @change="changed"
        class="field"
        dense
        hide-details
        :menu-props="{ bottom: true, offsetY: true }"
        outlined
      >
      </v-select>
    </v-col>
    <v-col cols="auto">
      <v-text-field
        :prepend-icon="items.length == 1 ? 'mdi-magnify' : null"
        label="Search"
        v-model="phrase"
        dense
        outlined
        hide-details
        clearable
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "SearchComp",

  data() {
    return {
      timer: 0,
      // value: "",
      // field: "",
    };
  },
  props: {
    value: VueTypes.any.def({}),
    items: VueTypes.any.def([]),
  },
  methods: {
    changed() {
      const val: any = {};
      val[this.field] = this.phrase;
      this.$emit("changed", { key: "search", val });
      this.$emit("input", { [this.field]: this.phrase });
    },
    searchEvent(val: string) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = 0;
      }
      this.timer = setTimeout(() => {
        this.$emit("input", { [this.field]: val });
      }, 700);
    },
  },
  computed: {
    search: {
      get(): unknown {
        return this.value;
      },
      set(val: unknown) {
        this.$emit("input", val);
      },
    },
    field: {
      get(): string {
        const field = `${Object.keys(this.search)[0]}`;
        return field;
      },
      set(field: string) {
        this.$emit("input", { [field]: this.phrase });
      },
    },
    phrase: {
      get(): string {
        const val = `${Object.values(this.search)[0]}`;
        return val;
      },
      set(val: string) {
        this.searchEvent(val);
      },
    },
  },
});
</script>

<style>
.field {
  width: 150px;
}
</style>
